module.exports = __webpack_public_path__ + "fonts/fa-solid-900---93f284548b42ab76fe3fd03a9d3a2180.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff
// module id = 380
// module chunks = 0